export const strings = {
  "pt-br": {
    Password: "Senha",
    "Enter your email": "Digite o seu email",
    "Enter your password": "Digite a sua senha",
    "Reset password": "Redefinir senha",
    "Sign in to your account": "Login",
    "Forget your password? ": "Esqueceu sua senha? ",
    "No account? ": "Sem conta? ",
    "Create account": "Criar nova conta",
    "Sign In": "Entrar",
    "Sign in": "Entrar",
    "User does not exist.": "O usuário não existe!",
    "Create a new account": "Criar uma nova conta",
    "Have an account? ": "Já possuí uma conta? ",
    "1 validation error detected: Value at 'password' failed to satisfy constraint: Member must have length greater than or equal to 6":
      "O campo senha deve possuir no mínimo 6 caracteres.",
    "Invalid email address format.":
      "Formato de email inválido. O email deve ser no formato email@dominio.com",
    "Create Account": "Criar nova conta",
    "Confirm Sign Up": "Confirmação de cadastro",
    "Confirmation Code": "Código de confirmação",
    "Lost your code? ": "Perdeu seu código? ",
    "Resend Code": "Reenvie o código",
    Confirm: "Confirmar",
    "Back to Sign In": "Voltar para o login",
    "An account with the given email already exists.":
      "Uma conta com o email informado já existe",
    "Incorrect username or password.": "Celular ou senha incorretos",
    "Custom auth lambda trigger is not configured for the user pool.": "Celular ou senha incorretos",
    "Username cannot be empty": "O campo email não pode ser vazio",
    "Request failed with status code 404": "Ocorreu um erro. Tente novamente!",
    "Campos inválidos": "Dados incorretos. Tente novamente!",
    "Reset your password": "Redefina sua senha",
    "Send Code": "Enviar o código",
    "Code": "Código",
    "New Password": "Nova senha",
    "Submit": "Enviar",
    "Password attempts exceeded": "Tentativas de senha excedidas"
  }
};

export const TERMS_URL = "https://sbtcaravanasdocs.s3.amazonaws.com/termo-de-uso/termos-de-uso-caravanas.pdf";
export const POLICY_URL = "https://sbtcaravanasdocs.s3.amazonaws.com/politica-de-privacidade/politica-de-privacidade-caravanas-v2.pdf";
export const UNDER_AGE_URL = "https://sbtcaravanasdocs.s3.amazonaws.com/cessao-de-imagem/caravanas-uso-de-imagem-v082021.pdf";
export const IMAGE_ASSIGNMENT =  "https://sbtcaravanasdocs.s3.amazonaws.com/cessao-de-imagem/cessao-de-imagem-sbt.pdf";